export default __webpack_public_path__ + "static/media/1.dcffa5e9.jpg";